class collectionFilters extends HTMLElement {
  constructor() {
    super();
    this.button_filters = this.querySelectorAll(".filter-group[data-type]");
    this.close_button = this.querySelector(".collection-filters-values__close");
    this.sort_by_select = document.querySelector(
      "facet-filters-form .select #SortBy"
    );
    this.sortButtons = this.querySelectorAll("[data-sort-by]");
    this.inputsCheckbox = document.querySelectorAll(
      '.list-menu__item [type="checkbox"][id]'
    );
    this.init();
    this.updateFiltersCounter();
    this.updateDisabledFilters();
    this.addEventListener(
      "update:checkboxs",
      this.updateFiltersCounter.bind(this)
    );

    /* close filters on click outside .collection-filters-values and [data-tag][data-type] */
    document.addEventListener("click", (e) => {
      if (
        !e.target.closest(".collection-filters-values") &&
        !e.target.closest("[data-tag][data-type]") &&
        !e.target.closest(".facet-checkbox") &&
        !e.target.closest("button.only-phone") &&
        !e.target.closest("collection-filters")
      ) {
        this.closeFilters();
      }
    });
  }

  init() {
    this.updateCheckkoxes();
    this.button_filters.forEach((button) => {
      button.addEventListener("click", this.toggleFilters.bind(this));
    });
    this.inputsCheckbox.forEach((input) => {
      input.addEventListener("change", this.updateCheckkoxes.bind(this));
    });
    this.sortButtons.forEach((button) => {
      button.addEventListener("click", this.updateSortBy.bind(this));
    });

    if (this.close_button) {
      this.close_button.addEventListener("click", this.closeFilters.bind(this));
    }

    console.log(this.querySelector(".drawer-menu__close"));
    if (this.querySelector(".drawer-menu__close")) {
      this.querySelector(".drawer-menu__close").addEventListener(
        "click",
        this.closeMobileFilters.bind(this)
      );
      this.querySelector(".apply-filters").addEventListener(
        "click",
        this.closeMobileFilters.bind(this)
      );
      document
        .querySelector(".collection-filters__collection-name button")
        .addEventListener("click", this.openMobileFilters.bind(this));
      document.querySelectorAll(".reset-filters").forEach((button) => {
        button.addEventListener("click", () => {
          document.querySelector(".active-facets__button-remove").click();
        });
      });
    }

    document
      .querySelectorAll(
        "[data-type] #Filter-Prix-GTE, [data-type] #Filter-Prix-LTE"
      )
      .forEach((input) => {
        input.addEventListener("change", () => {
          document
            .querySelectorAll("facet-filters-form #" + input.getAttribute("id"))
            .forEach((input2) => {
              input2.value =
                input.value > parseFloat(input.getAttribute("max"))
                  ? parseFloat(input.getAttribute("max"))
                  : input.value;
              document
                .querySelector("#FacetFiltersForm")
                .dispatchEvent(new Event("input"));
            });
        });
      });
  }

  closeMobileFilters() {
    this.classList.remove("actif");
    if (!(window.location.href.indexOf("search") > -1)) {
      document.querySelector("body").classList.remove("shadow-drawer");
    }
  }

  openMobileFilters() {
    if (!(window.location.href.indexOf("search") > -1)) {
      document.querySelector("body").classList.add("shadow-drawer");
    }
    this.classList.add("actif");
  }

  toggleFilters(e) {
    let button = e.currentTarget;
    let filters_container = this.querySelector(".collection-filters-values");
    let filters_values_container = filters_container.querySelector(
      `[data-type="${button.dataset.type}"][data-tag="${button.dataset.tag}"]`
    );
    let active = button.classList.contains("active");

    if (active) {
      button.classList.remove("active");
      filters_container.classList.remove("active");
      document
        .querySelectorAll(
          ".collection-filters__collection-name, collection-filters"
        )
        .forEach((element) => {
          element.classList.remove("actif");
        });
      if (!(window.location.href.indexOf("search") > -1)) {
        document.querySelector("body").classList.remove("shadow-drawer");
      }
      filters_values_container
        ? filters_values_container.classList.remove("active")
        : null;
    } else {
      this.button_filters.forEach((button) => {
        button.classList.remove("active");
      });
      button.classList.add("active");
      document
        .querySelectorAll(
          ".collection-filters__collection-name, collection-filters"
        )
        .forEach((element) => {
          element.classList.add("actif");
        });
      if (!(window.location.href.indexOf("search") > -1)) {
        document.querySelector("body").classList.add("shadow-drawer");
      }
      filters_container.classList.add("active");
      filters_container.querySelectorAll("[data-type]").forEach((element) => {
        element.classList.remove("active");
      });
      filters_values_container
        ? filters_values_container.classList.add("active")
        : null;
    }
  }

  closeFilters() {
    this.button_filters.forEach((button) => {
      button.classList.remove("active");
    });
    this.querySelector(".collection-filters-values").classList.remove("active");
    document
      .querySelectorAll(
        ".collection-filters__collection-name, collection-filters"
      )
      .forEach((element) => {
        element.classList.remove("actif");
      });
    if (!(window.location.href.indexOf("search") > -1)) {
      document.querySelector("body").classList.remove("shadow-drawer");
    }
  }

  updateCheckkoxes() {
    let checkboxs = this.inputsCheckbox;
    checkboxs.forEach((input) => {
      if (document.querySelector(`[id2="${input.id}"]`))
        document.querySelector(`[id2="${input.id}"]`).checked = input.checked;
    });
    // setTimeout(
    //   function () {
    //     this.inputsCheckbox = document.querySelectorAll(
    //       '.list-menu__item [type="checkbox"][id]'
    //     );
    //     this.inputsCheckbox.forEach((input) => {
    //       input.removeEventListener("change", this.updateCheckkoxes.bind(this));
    //       input.addEventListener("change", this.updateCheckkoxes.bind(this));
    //     });
    //   }.bind(this),
    //   2000
    // );

    this.updateFiltersCounter();
  }

  updateFiltersCounter() {
    if (!this.button_filters) {
      this.button_filters = this.querySelectorAll(".filter-group[data-type]");
    }
    let counter_global = 0;
    this.button_filters.forEach((button) => {
      let counter = 0;
      let filters_values_container = document.querySelector(
        `.filters-values__item[data-type="${button.dataset.type}"][data-tag="${button.dataset.tag}"]`
      );
      console.log(filters_values_container);
      filters_values_container.querySelectorAll("[id2]").forEach((checkbox) => {
        if (checkbox.checked) counter++;
      });
      console.log(counter);

      counter_global += counter;

      if (counter > 0) {
        button.querySelector("label span").innerHTML =
          button
            .querySelector("label span")
            .innerHTML.replace(/\s\(\d+\)/, "") + ` (${counter})`;
        button.classList.add("active-facet");
      } else {
        button.querySelector("label span").innerHTML = button
          .querySelector("label span")
          .innerHTML.replace(/\s\(\d+\)/, "");
        button.classList.remove("active-facet");
      }
    });

    if (!document.querySelector(".reset-filters")) return;
    if (counter_global > 0) {
      document.querySelector(".reset-filters").classList.remove("hidden");
    } else {
      document.querySelector(".reset-filters").classList.add("hidden");
    }
  }

  updateDisabledFilters() {
    document.querySelectorAll(".facet-checkbox span").forEach((span) => {
      if (span.innerHTML.indexOf("(0)") > -1) {
        span.classList.add("disabled");
      } else {
        span.classList.remove("disabled");
      }
    });
  }

  updateSortBy(e) {
    let button = e.currentTarget;
    this.sortButtons.forEach((button) => {
      button.closest(".sort-by-group").classList.remove("active");
    });
    button.closest(".sort-by-group").classList.add("active");
    document.querySelector("facet-filters-form .select #SortBy").value =
      button.dataset.sortBy;
    document
      .querySelector("#FacetFiltersForm")
      .dispatchEvent(new Event("input"));
  }
}

customElements.define("collection-filters", collectionFilters);
